import angular from 'angular';
import moment from 'moment-timezone';
import * as $ from 'jquery';
import { routes } from '../../../src/app/app.routes';
/* eslint-disable */
// const nrtemplate = `(function () {
//     ;NREUM.info={beacon:"bam.nr-data.net",errorBeacon:"bam.nr-data.net",licenseKey:"de174846e9",applicationID:"{{NEW_RELIC_KEY}}",sa:1,agent:"js-agent.newrelic.com/nr-885.min.js"}
//   })();
// `;

/* eslint-enable */

/* eslint max-params: 0 */
// Helper function to check route match for Angular router
function matchAngularRoute(url, routes, basePath) {
  for (const route of routes) {
    const path = basePath + '/' + route.path;
    if(url === path) {
      return { route, isNew: true }
    }
    if (route.children?.length) {
      return matchAngularRoute(url, route.children, path);
    }
  }
  return null;
}

const run = function run(Services, $rootScope, $state, $window, $log, $timeout, Auth, Logger, ENV, API_URL, Polling, NgRouter) {
  'ngInject';
  let current_route = null;

  /* Log our environment */
  Logger.debug(`ENV: ${ENV}`);
  Logger.debug(`URL: ${API_URL}`);


  /* eslint no-eval: 0 */

  /* Attach a configuration object to the root scope for easy use in views ( $root ) */
  Object.assign($rootScope, {
    config: {
      ENV,
      API: API_URL,
      colors: {
        primary: '#1d244d',
        success: '#77c660',
      },
    },
  });
  Polling.bootstrapWorker();

  $rootScope.$on('$stateChangeStart', (event, next, nextParams, from, fromParams = {}) => {
    const fullUrl = $state.href(next.name, nextParams, { absolute: false });
    const url = new URL(fullUrl, window.location.origin); // create a URL object
    const path = url.pathname;  // '/gp-letters/unverified_addresses'
    const currentNavigation = NgRouter.getCurrentNavigation();

    if(current_route !== next.name && from.name !== "") {
      current_route = next.name;
      if (currentNavigation?.finalUrl?.toString() !== path) {
        const queryParams = Object.fromEntries(url.searchParams.entries());
        // NgRouter.navigate([path], { queryParams });
      }
    }


    // THIS FIXES THE BUG WHEN
    // DOCTOR MOVES OUT TO OTHER SCREEN OR URL
    // AND THE ACTIVE VIDEOCALL WINDOW FOR CURRENT VISIT GETS LOST
    //
    // NOW, WHEN THIS HAPPENS, PIMS WILL:
    //   HANGUP THE VIDEOCALL,
    //   FINALIZE THE VIDEOCALL ON DB,
    //   AND WILL ASK THE PATIENT TO REDO THE VIDEO
    if ($rootScope.videoSession) {
      $rootScope.$broadcast('checkResetVideoCalls');
    }


    /* User is logged in */
    if (Auth.isLoggedIn()) {
      Polling.setupSession(Auth.getToken());

      if (!$rootScope.timezones) {

        // SOURCE:
        // https://momentjs.com/timezone/docs/#/using-timezones/formatting/

        let abbrs = {
          EST : 'Eastern Standard Time',
          EDT : 'Eastern Daylight Time',
          CST : 'Central Standard Time',
          CDT : 'Central Daylight Time',
          MST : 'Mountain Standard Time',
          MDT : 'Mountain Daylight Time',
          PST : 'Pacific Standard Time',
          PDT : 'Pacific Daylight Time',
          HST : 'Hawaii Standard Time',
          HDT : 'Hawaii Daylight Time',
          SST : 'Samoa Standard Time',
          AKST : 'Alaska Standard Time',
          AKDT : 'Alaska Daylight Time',
          BST : 'British Summer Time',
          GMT : 'Greenwich Mean Time'
        };

        // SOURCE:
        // https://github.com/moment/moment-timezone/blob/develop/data/packed/latest.json

        let timezoneFullList = [
          "America/Adak|US/Aleutian",
          "America/Anchorage|US/Alaska",
          "America/Chicago|US/Central",
          "America/Denver|US/Mountain",
          "America/Detroit|US/Michigan",
          "America/Fort_Wayne|US/East-Indiana",
          "America/Indiana/Knox|US/Indiana-Starke",
          "America/Los_Angeles|US/Pacific",
          "America/Los_Angeles|US/Pacific-New",
          "America/New_York|US/Eastern",
          "America/Phoenix|US/Arizona",
          "Pacific/Honolulu|US/Hawaii",
          "Pacific/Pago_Pago|US/Samoa",
        ];

        let timezoneReducedList = [
          "Europe/London|UK/United Kingdom",
          "America/Los_Angeles|US/Pacific",
          "America/Denver|US/Mountain",
          "America/Chicago|US/Central",
          "America/New_York|US/Eastern",
          "America/Anchorage|US/Alaska",
          "Pacific/Honolulu|US/Hawaii"
        ];

        // var today = moment().format('YYYY-MM-DD');
        // var zoneAbbr = moment.tz(today, 'America/Los_Angeles').format('z');
        // var zoneName = moment.tz(today, 'America/Los_Angeles').format('zz');
        // var zoneAbbr2 = moment.tz(today, 'America/Los_Angeles').zoneAbbr();
        // var zoneName2 = moment.tz(today, 'America/Los_Angeles').zoneName();

        // var zoneAbbr = moment.tz('America/Los_Angeles').format('z');
        // var zoneName = abbrs[zoneAbbr] || zoneAbbr;

        let timezones = [];

        timezoneReducedList.forEach((tz) => {

          let timezone = tz.split("|")[0];
          let zoneAbbr = moment.tz(timezone).format('z');
          let zoneName = abbrs[zoneAbbr] || zoneAbbr;

          let obj = {
            timezone: timezone,
            zoneName: zoneName,
            zoneAbbr: zoneAbbr,
          }

          timezones.push(obj);
        });

        console.log("timezones: ",timezones);

        $rootScope.timezones = timezones;
      }


      Services.getCacheAreaCodes(false)
        .then(() => {})
        .catch(() => {});

      /* States like "login" should not be accessed when logged in */
      if (next.blockWhenAuthenticated) {
        event.preventDefault();
        $state.go(from.name || 'visits', fromParams);
      }

      /* User has stored token */
    } else if (Auth.getToken()) {

      event.preventDefault();

      Auth.getProfile()
        .then(() => {
          $state.go(next, nextParams, { location: true })
        })
        .catch(() => {
          Auth.logout(next)
        });

      /* Neither and the next state is secure */
    } else if (next.authenticate) {

      event.preventDefault();
      $state.go('login');
    }
  });

  /**
   * TODO: need to figure out how to send the params to NgRouter.navigate function
   * ... note that the issue will be sending the params in the correct order
   * ... for example:
   * ... a route /visits/:id/something/:abc should be sent as
   * ... NgRouter.navigate(['/visits, {id: 123}, '/something', {abc: 'test'}]
   *
   * double check that is the correct syntax. Otherwise there is navigateByUrl()
   * @param params
   * @param placeholder
   * @param url
   */
  const updatePageTitle = (params, placeholder, url) => {
    if (placeholder) {
      const match = matchAngularRoute(url, routes, '');
      if (match) {
        // TODO: when the new route and login flow is setup this will need to be revisited.
       //NgRouter.navigate([url]);
      }
    } else {
      throw new Error('Please provide pageTitle in the state definition.');
    }
    _.each(params, (val, key) => { placeholder = placeholder.replace(`:${key}`, val); });
    $rootScope.pageTitle = placeholder;
  };

  $rootScope.$on('$stateChangeSuccess', (event, next, nextParams) => {


    $timeout(() => {
      if (next.name === 'visits' || next.name === 'visitDetail') {
        $("#menu_visits").addClass("nav-active");
      } else {
        $("#menu_visits").removeClass("nav-active");
      }

      if (next.name === 'users' || next.name === 'userDetail') {
        $("#menu_patients").addClass("nav-active");
      } else {
        $("#menu_patients").removeClass("nav-active");
      }
    });


    /* Dynamically update page title */
    updatePageTitle(nextParams, next.pageTitle, next.url);
  });

  /* Catch 401s in HTTP Interceptor and log user out */
  $rootScope.$on('unauthorized', () => {
    Auth._actuallyLogout("login");
  });
};

run.$inject = ["Services", "$rootScope", "$state", "$window", "$log", "$timeout", "Auth", "Logger", "ENV", "API_URL", "Polling", "NgRouter"];
angular.module('pims').run(run);
